/** Ad-attribution UTM params read once from the embedding page's URL. */
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

export function readUtms(search?: string): UtmParams | null {
  const query = search ?? (typeof window !== "undefined" ? window.location.search : "");
  if (!query) return null;
  const params = new URLSearchParams(query);
  const utms: UtmParams = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) utms[key] = value.slice(0, 256);
  }
  return Object.keys(utms).length > 0 ? utms : null;
}
